import { defineMessages } from 'react-intl';

export default defineMessages({

  'msg_loading' : {
    'id': 'admin.msg.default.loading',
    'defaultMessage': 'Loading'
  },
  'msg_empty_filter' : {
    'id': 'admin.msg.default.empty_filter',
    'defaultMessage': 'The filter returned no results'
  }

});